export enum OrderEnum {
  'USER_DETAILS_CLICKED' = 'user_details_clicked',
}

export enum OrderTypeEnum {
  DINE_IN = 0,
  DELIVERY = 1,
  TAKEAWAY = 2,
  PICKUP = 'pickup'
}
export enum OrderRevertReasonEnum {
  CAN_BE_REVERTED = 1,
  NOT_SAME_DAY = 2,
  ALREADY_SETTLED = 3,
  SCHEDULED = 4,
  REFUND_CASE = 5,
}

export enum OrderDeleteReasonEnum {
  CAN_BE_DELETED = 1,
  NOT_SAME_DAY = 2,
  ALREADY_SETTLED = 3,
  REFUND_CASE = 5,
  KIOSK_ORDER = 6
}

export enum PlatformEnum {
  EASYEAT = 'easyeat'
}
export enum INVALID_NUMBER_ENUM {
  'ZERO' = 0,
  'FIFTEEN' = 15,
}

export enum SERVICE_CHARGE_ENUM {
  TABLE_SERVICE_CHARGE = 'table_service_charge',
  APPLY = 'apply',
  REMOVE = 'remove'
}
